import React, { useState } from 'react';
import { Modal, Button } from '@scale/scaleui';
import { makeStyles } from 'react-scale/components/design-system';
import { Checkbox } from 'design-system';
import SAlert from 'react-s-alert';

interface CompleteSpeedAuditModalProps {
  isCompleteAuditModalOpen: boolean;
  setCompleteAuditModalOpen: (isOpen: boolean) => void;
  speedAuditBatch: string;
  completeAudit: (sendFeedback: boolean) => void;
}

export const CompleteSpeedAuditModal = ({
  isCompleteAuditModalOpen,
  setCompleteAuditModalOpen,
  speedAuditBatch,
  completeAudit,
}: CompleteSpeedAuditModalProps) => {
  const [sendFeedback, setSendFeedback] = useState<boolean>(false);

  const submitHelper = async () => {
    setCompleteAuditModalOpen(false);
    try {
      await completeAudit(sendFeedback);
    } catch (e) {
      SAlert.error(e.message);
    }
  };

  const classes = useStyles();

  return (
    <Modal
      open={isCompleteAuditModalOpen}
      onClose={() => {
        setCompleteAuditModalOpen(false);
      }}
      title={`Complete Speed Audit batch: ${speedAuditBatch}`}
    >
      <div className={classes.completeModal}>
        <div className="mt-4">
          <div
            style={{ display: 'flex', alignItems: 'left', flexDirection: 'column', gap: '16px' }}
          >
            <Checkbox
              label="Send feedback to taskers as a course or review feedback"
              checked={sendFeedback}
              onChange={e => setSendFeedback(e.target.checked)}
            />
            <div style={{ maxWidth: '200px' }}>
              <Button size="lg" onClick={submitHelper}>
                Complete Audit
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

const useStyles = makeStyles(() => ({
  completeModal: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    width: 500,
    gap: '16px',
  },
  summaryContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  summaryHeader: {
    fontSize: '16x',
    fontWeight: 'bold',
  },
  breakdownHeader: {
    marginTop: '12px', // Reduced space
    fontSize: '16x',
    fontWeight: 'bold',
  },
  summaryList: {
    paddingLeft: '20px',
    marginBottom: '4px', // Reduced space
  },
  statusItem: {
    display: 'flex',
    alignItems: 'center',
  },
}));
